var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Header',{attrs:{"background":`https://alkafeel.net/photos/imager/950967-964A4073.jpg/NzIw`}}),(_vm.$store.state.options.moharam)?_c('Moharam'):_vm._e(),_c('div',{staticClass:"main-content"},[_c('Gallery',{attrs:{"navs":[{
          title: 'الاحدث',
          category: 0,
          sort: 'add_desc'
        },
        {
          title: 'صور مختارة',
          category: 0,
          sort: 'random'
        },
        {
          title: 'العتبة الحسينية',
          category: '122',
          sort: 'add_desc'
        },
        {
          title: 'مناسبات دينية',
          category: '152',
          sort: 'add_desc'
        }
      ]}})],1),_c('div',[_c('Footer')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }